module.exports = require('./dist').PMT